<script>
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'GuinnessTips',
  props: {
    title: {
      type: String,
      required: true
    },
    msg: {
      type: String,
      required: false
    },
    msgred: {
      type: String,
      required: false
    }
  },
  setup() {
    return {}
  }
})
</script>

<template>
  <div class="GuinnessTips">
    <div class="GuinnessTipsH">
      <span class="GuinnessTipsHBar"></span>
      <span class="GuinnessTipsHT">{{ title }}</span>
    </div>
    <span v-if="msg" class="GuinnessTipsMsg">{{ msg }}</span>
    <span v-if="msgred" class="GuinnessTipsMsgRed">{{ msgred }}</span>
  </div>
</template>

<style lang="scss" scoped>
.GuinnessTips {
  width: 100%;
  margin-top: 1.875rem;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-content: center;

  &H {
    display: flex;
    flex-direction: row;
    align-items: center;
    &T {
      font-size: 1.875rem;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #0d0d0d;
      // line-height: 3.75rem;
      margin-left: 0.875rem;
    }
    &Bar {
      width: 0.625rem;
      height: 1.75rem;
      background-color: #5a2cf0;
    }
  }
  &Msg {
    width: 100%;
    margin-top: 1.25rem;
    font-size: 1rem;
    font-family: MicrosoftYaHei;
    font-weight: 300;
    color: #0d0d0d;
    // line-height: 1.625rem;
    text-align: start;
    white-space: pre-wrap;
  }
  &MsgRed {
    width: 100%;
    font-size: 1rem;
    font-family: MicrosoftYaHei;
    font-weight: 300;
    color: red;
    // line-height: 1.625rem;
    text-align: start;
    white-space: pre-wrap;
  }
}
</style>
